export default __webpack_public_path__ + "static/media/Poppins-Regular.35d26b78.ttf";